import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/common/apiClient";
import { toast } from "sonner";
export const useKPIQuestionLists = () => {
  return useQuery({
    queryKey: ["kpi-question-lists"],
    queryFn: async () => {
      const response = await apiClient.get("/api/kpi-question-list");
      if (response.success) {
        toast.success("KPI question lists fetched successfully");
        return response.data;
      } else {
        toast.error(response.message || "Failed to fetch KPI question lists");
        return null;
      }
    },
  });
};
